export * from './vorlage-detail.component';
export * from './vorlage-detail.component.module';